module.exports = __webpack_public_path__ + "media/svg-new/logo-maxia-blue-89a065ec.svg";